
:host {
  grid-column: 1;
  grid-row: 1 / -1;
  display: flex;
  position: relative;
  aspect-ratio: 1 / 1;
  background-color: rgb(227, 227, 227);
  border-radius: 8px;
  overflow: hidden;
  .thumbnail {
    position: absolute;
    bottom: 4px;
    right: 4px;
    object-fit: cover;
    height: 36px;
    aspect-ratio: 1 / 1;
    border-radius: 4px;
    box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 4px;
    background-color: rgb(227, 227, 227);
    cursor: pointer;
  }
  .preview {
    width: 100%;
    height: 100%;
    aspect-ratio: 1 / 1;
    opacity: 1;
    position: absolute;
  }

}
